import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {REDIRECT_TO_LEGACY_LOGIN} from '../core/helpers/redirect';
import {AuthService} from '../core/services/auth.service';
import {NavigateAfterLoginService} from 'app/features/sign-in/services/navigate-after-login.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        private auth: AuthService,
        @Inject(REDIRECT_TO_LEGACY_LOGIN) public redirectToLogin: () => void,
        private afterLogin: NavigateAfterLoginService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.auth.isLoggedIn()) {
            this.redirectToLogin();
            return false;
        }

        this.afterLogin.flushBackUrlRedirectCount();

        return true;
    }
}
